module.exports = __webpack_public_path__ + "static/media/tiki.34b26b79.png";